// extracted by mini-css-extract-plugin
module.exports = {"MarkdownDocument":"MarkdownDocument_MarkdownDocument__ACBPI"};